// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerPopup.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.ReportViewerPopupActions';
import { SUBREPORT_POPUP } from 'logic/data/Izenda.ReportsConstants';
import ReportBodyViewer from 'share/components/views/Izenda.ReportBodyViewer';
import { setDisplayName } from 'recompose';
import { uniqueId } from 'lodash/fp';

function ReportViewerPopup({ localization, onClosing, queryObject, reportId }) {
  const style = {
    width: SUBREPORT_POPUP.frameWidthInPercent,
    height: SUBREPORT_POPUP.frameHeightInPx
  };

  return (
    <Popup visible onClosing={onClosing} type="none" autoClose={false} sizeClass="modal-lg">
    <Popup.Header title={SUBREPORT_POPUP.popupTitle} />
  <Popup.Body>
    <div style={style}>
      <ReportBodyViewer hideGridPopup hideHeaderFooter id={reportId} queryObject={queryObject} />
    </div>
  </Popup.Body>
  <Popup.Footer>
  <Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
</Popup.Footer>
</Popup>
  );
}

export default function() {
  // We need to generate an unit name for displayName in case of opening Sub popup (a popup is oppned in parent popup)
  var name = uniqueId('ReportViewerPopup_');
  var Comp = setDisplayName(name)(connect(actions)(ReportViewerPopup));
  // popupName is a key that help we get displayName. We need this key get display name in case of minimize code
  Comp.$popupName = name;
  return Comp;
}



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportViewer/Izenda.ReportViewerPopup.js